export default __webpack_public_path__ + "static/media/hr.76c0a5e2.svg";